import { ILineItemDuplicate } from '@/Interfaces/CampaignManagement/LineItem.interface';

export const NEW_LINE_ITEM_DUPLICATE: ILineItemDuplicate = {
  name: '',
  startDate: null,
  endDate: null,
  impressionsBooked: '',
  product: null,
  packageId: null,
  channel: null,
};
